import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg';

function SavingMoney(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(G, {
    clipPath: "url(#prefix__clip0_657_38)"
  }, React.createElement(Path, {
    fillRule: "evenodd",
    d: "M7.855 19.384a8.955 8.955 0 01-3.393-4.535l2.09 1.045a1 1 0 10.895-1.788l-4-2a1 1 0 00-1.28.34l-2 3a1 1 0 101.665 1.109l.727-1.09a10.955 10.955 0 004.152 5.56c4.985 3.473 11.84 2.248 15.314-2.736 3.473-4.985 2.248-11.84-2.736-15.314C14.304-.498 7.449.727 3.975 5.711a1 1 0 101.64 1.144 9 9 0 112.24 12.53zm8.038-10.248a.75.75 0 10-1.286-.772l-4.5 7.5a.75.75 0 101.286.772l4.5-7.5zM16 15.75a.75.75 0 100-1.5.75.75 0 000 1.5zM16 17a2 2 0 100-4 2 2 0 000 4zm-5.25-7a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12 10a2 2 0 11-4 0 2 2 0 014 0z",
    clipRule: "evenodd"
  })), React.createElement(Defs, null, React.createElement(ClipPath, {
    id: "prefix__clip0_657_38"
  }, React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}

export default SavingMoney;